import * as ABM_ART_Articulos from './src/funciones/ABM/ART/ABM_ART_Articulos';
import * as ABM_ART_Articulos_CodigosBarra from './src/funciones/ABM/ART/ABM_ART_Articulos_CodigosBarra';
import * as ABM_ART_Articulos_Reservables from './src/funciones/ABM/ART/ABM_ART_Articulos_Reservables';
import * as ABM_ART_Articulos_Reservables_AforoReservado from './src/funciones/ABM/ART/ABM_ART_Articulos_Reservables_AforoReservado';
import * as ABM_ART_Articulos_Reservables_Excepciones from './src/funciones/ABM/ART/ABM_ART_Articulos_Reservables_Excepciones';
import * as ABM_ART_Presentaciones from './src/funciones/ABM/ART/ABM_ART_Presentaciones';
import * as ABM_ART_SubtiposCompras from './src/funciones/ABM/ART/ABM_ART_SubtiposCompras';
import * as ABM_ART_SubtiposVentas from './src/funciones/ABM/ART/ABM_ART_SubtiposVentas';
import * as ABM_ART_Tamanos from './src/funciones/ABM/ART/ABM_ART_Tamanos';
import * as ABM_ART_TiposCompras from './src/funciones/ABM/ART/ABM_ART_TiposCompras';
import * as ABM_ART_TiposVentas from './src/funciones/ABM/ART/ABM_ART_TiposVentas';
import * as ABM_ART_UnidadesMedida from './src/funciones/ABM/ART/ABM_ART_UnidadesMedida';
import * as ABM_CON_Bancos from './src/funciones/ABM/CONT/ABM_CON_Bancos';
import * as ABM_CON_CentrosCosto from './src/funciones/ABM/CONT/ABM_CON_CentrosCosto';
import * as ABM_CON_CondicionesVenta from './src/funciones/ABM/CONT/ABM_CON_CondicionesVenta';
import * as ABM_CON_CuentasContables from './src/funciones/ABM/CONT/ABM_CON_CuentasContables';
import * as ABM_CON_CuentasFinancieras from './src/funciones/ABM/CONT/ABM_CON_CuentasFinancieras';
import * as ABM_CON_CuentasFinancierasTipos from './src/funciones/ABM/CONT/ABM_CON_CuentasFinancierasTipos';
import * as ABM_CON_Monedas from './src/funciones/ABM/CONT/ABM_CON_Monedas';
import * as ABM_CON_SubCentrosCosto from './src/funciones/ABM/CONT/ABM_CON_SubCentrosCosto';
import * as ABM_EEX_Clientes from './src/funciones/ABM/EEX/ABM_EEX_Clientes';
import * as ABM_EEX_ClientesSocios from './src/funciones/ABM/EEX/ABM_EEX_ClientesSocios';
import * as ABM_EEX_LocacionesTipos from './src/funciones/ABM/EEX/ABM_EEX_LocacionesTipos';
import * as ABM_EEX_Personas from './src/funciones/ABM/EEX/ABM_EEX_Personas';
import * as ABM_EEX_Profesionales from './src/funciones/ABM/EEX/ABM_EEX_Profesionales';
import * as ABM_EEX_ProfesionalesTipos from './src/funciones/ABM/EEX/ABM_EEX_ProfesionalesTipos';
import * as ABM_EEX_Proveedores from './src/funciones/ABM/EEX/ABM_EEX_Proveedores';
import * as ABM_GEO_Ciudades from './src/funciones/ABM/GEO/ABM_GEO_Ciudades';
import * as ABM_GEO_Paises from './src/funciones/ABM/GEO/ABM_GEO_Paises';
import * as ABM_GEO_ProvinciasEstados from './src/funciones/ABM/GEO/ABM_GEO_ProvinciasEstados';
import * as ABM_IMP_PuntosFiscales from './src/funciones/ABM/IMP/ABM_IMP_PuntosFiscales';
import * as ABM_IMP_TiposIVA from './src/funciones/ABM/IMP/ABM_IMP_TiposIVA';
import * as ABM_IMP_ImpuestosTipos from './src/funciones/ABM/IMP/ABM_IMP_ImpuestosTipos';
import * as ABM_IMP_Terminales from './src/funciones/ABM/IMP/ABM_IMP_Terminales';
import * as ABM_TRA_EmpresasTransporte from './src/funciones/ABM/TRA/ABM_TRA_EmpresasTransporte';
import * as ABM_TRA_EmpresasTransporteLocaciones from './src/funciones/ABM/TRA/ABM_TRA_EmpresasTransporteLocaciones';
import * as ABM_TRA_Transportes from './src/funciones/ABM/TRA/ABM_TRA_Transportes';
import * as ABM_TRA_TransportesTipos from './src/funciones/ABM/TRA/ABM_TRA_TransportesTipos';
import * as ABM_TRA_Transportistas from './src/funciones/ABM/TRA/ABM_TRA_Transportistas';
import * as ABM_ZON_Companias from './src/funciones/ABM/ZON/ABM_ZON_Companias';
import * as ABM_ZON_Depositos from './src/funciones/ABM/ZON/ABM_ZON_Depositos';
import * as ABM_ZON_Empresas from './src/funciones/ABM/ZON/ABM_ZON_Empresas';
import * as ABM_ZON_Plantas from './src/funciones/ABM/ZON/ABM_ZON_Plantas';
import * as ABM_ZON_Ubicaciones from './src/funciones/ABM/ZON/ABM_ZON_Ubicaciones';
import * as COM_Cotizaciones_Cabecera from './src/funciones/COM/Cotizaciones/COM_Cotizaciones_Cabecera';
import * as COM_DocsCompra_Cabecera from './src/funciones/COM/DocsCompra/COM_DocsCompra_Cabecera';
import * as COM_DocsCompra_Tipos from './src/funciones/COM/DocsCompra/COM_DocsCompra_Tipos';
import * as COM_Pagos_Cabecera from './src/funciones/COM/Pagos/COM_Pagos_Cabecera';
import * as COM_Pagos_Anticipos from './src/funciones/COM/Pagos/COM_Pagos_Anticipos';
import * as COM_Pedidos_Cabecera from './src/funciones/COM/Pedidos/COM_Pedidos_Cabecera';
import * as COM_Pedidos_Detalle from './src/funciones/COM/Pedidos/COM_Pedidos_Detalle';
import * as COM_Recepciones_Cabecera from './src/funciones/COM/Recepciones/COM_Recepciones_Cabecera';
import * as COM from './src/funciones/COM/COM';
import * as CON_Asientos from './src/funciones/CONT/CON_Asientos';
import * as CON_Cheques from './src/funciones/CONT/CON_Cheques';
import * as CON_OperacionesParaImportar from './src/funciones/CONT/CON_OperacionesParaImportar';
import * as CON_Plantilla_OperacionesParaImportar_Cabecera from './src/funciones/CONT/CON_Plantilla_OperacionesParaImportar_Cabecera';
import * as CON_Transferencias from './src/funciones/CONT/CON_Transferencias';
import * as CONT_Reportes from './src/funciones/CONT/CONT_Reportes';
import * as INV_Remitos_Cabecera from './src/funciones/INV/Remitos/INV_Remitos_Cabecera';
import * as INV_MovimientoInventario from './src/funciones/INV/INV_MovimientoInventario';
import * as MKT_Correos_AEnviar from './src/funciones/MKT/MKT_CorreosAEnviar';
import * as PRO_Articulos_BOM from './src/funciones/PRO/PRO_Articulos_BOM';
import * as PRO_Fabricacion_Cabecera from './src/funciones/PRO/PRO_Fabricacion_Cabecera';
import * as PRO_Fabricacion_Etapas_Cabecera from './src/funciones/PRO/PRO_Fabricacion_Etapas_Cabecera';
import * as PRO_Fabricacion_Tipos from './src/funciones/PRO/PRO_Fabricacion_Tipos';
import * as STK_ART_Consumo from './src/funciones/STK/STK_ART_Consumo';
import * as STK_ART_Merma from './src/funciones/STK/STK_ART_Merma';
import * as STK_ART_Stock from './src/funciones/STK/STK_ART_Stock';
import * as VEN_CierresDeCaja_Cabecera from './src/funciones/VEN/CierresDeCaja/VEN_CierresDeCaja_Cabecera';
import * as VEN_CierresDeCaja_Totales from './src/funciones/VEN/CierresDeCaja/VEN_CierresDeCaja_Totales';
import * as VEN_Cotizaciones_Cabecera from './src/funciones/VEN/Cotizaciones/VEN_Cotizaciones_Cabecera';
import * as VEN_DocsVenta_Cabecera from './src/funciones/VEN/DocsVenta/VEN_DocsVenta_Cabecera';
import * as VEN_DocsVenta_Tipos from './src/funciones/VEN/DocsVenta/VEN_DocsVenta_Tipos';
import * as VEN_ListasPrecios_Cabecera from './src/funciones/VEN/ListasPrecios/VEN_ListasPrecios_Cabecera';
import * as VEN_ListasPrecios_Detalle from './src/funciones/VEN/ListasPrecios/VEN_ListasPrecios_Detalle';
import * as VEN_Pedidos_Cabecera from './src/funciones/VEN/Pedidos/VEN_Pedidos_Cabecera';
import * as VEN_Pedidos_Detalle from './src/funciones/VEN/Pedidos/VEN_Pedidos_Detalle';
import * as VEN_PVenta_ArticulosDisponiblesParaEgresos from './src/funciones/VEN/PVenta/VEN_PVenta_ArticulosDisponiblesParaEgresos';
import * as VEN_PVenta_Disposicion_Botones from './src/funciones/VEN/PVenta/VEN_PVenta_Disposicion_Botones';
import * as VEN_PVenta_Disposicion_BotonesReservables from './src/funciones/VEN/PVenta/VEN_PVenta_Disposicion_BotonesReservables';
import * as VEN_PVenta_Disposicion_CuentasFinancieras from './src/funciones/VEN/PVenta/VEN_PVenta_Disposicion_CuentasFinancieras';
import * as VEN_PVenta_Disposicion_Grupos from './src/funciones/VEN/PVenta/VEN_PVenta_Disposicion_Grupos';
import * as VEN_PVenta_Mesas from './src/funciones/VEN/PVenta/VEN_PVenta_Mesas';
import * as VEN_Recibos_Anticipos from './src/funciones/VEN/Recibos/VEN_Recibos_Anticipos';
import * as VEN_Recibos_Cabecera from './src/funciones/VEN/Recibos/VEN_Recibos_Cabecera';
import * as VEN_Reservas_Cabecera from './src/funciones/VEN/Reservas/VEN_Reservas_Cabecera';
import * as VEN_Reservas_Detalle from './src/funciones/VEN/Reservas/VEN_Reservas_Detalle';
import * as VEN_Reservas_Integrantes from './src/funciones/VEN/Reservas/VEN_Reservas_Integrantes';
import * as VEN_Reservas_MercadoPago from './src/funciones/VEN/Reservas/VEN_Reservas_MercadoPago';
import * as VEN_Reservas_Pulseras from './src/funciones/VEN/Reservas/VEN_Reservas_Pulseras';
import * as VEN from './src/funciones/VEN/VEN';
import * as VariablesGenerales from './src/funciones/VariablesGenerales';
import * as Varios from './src/funciones/Varios';
import * as Mensajes from './src/funciones/Mensajes';
import * as TODOS_Dashboard from './src/funciones/TODOS_Dashboard';
import * as TODOS_Menues from './src/funciones/TODOS_Menues';
import * as TODOS_Menues_Visibilizar from './src/funciones/TODOS_Menues_Visibilizar';
import * as TODOS_AsistenciaEnLinea_Mensajes from './src/funciones/TODOS_AsistenciaEnLinea_Mensajes';

export {
    ABM_ART_Articulos,
    ABM_ART_Articulos_CodigosBarra,
    ABM_ART_Articulos_Reservables,
    ABM_ART_Articulos_Reservables_AforoReservado,
    ABM_ART_Articulos_Reservables_Excepciones,
    ABM_ART_Presentaciones,
    ABM_ART_SubtiposCompras,
    ABM_ART_SubtiposVentas,
    ABM_ART_Tamanos,
    ABM_ART_TiposCompras,
    ABM_ART_TiposVentas,
    ABM_ART_UnidadesMedida,
    ABM_CON_Bancos,
    ABM_CON_CentrosCosto,
    ABM_CON_CondicionesVenta,
    ABM_CON_CuentasContables,
    ABM_CON_CuentasFinancieras,
    ABM_CON_CuentasFinancierasTipos,
    ABM_CON_Monedas,
    ABM_CON_SubCentrosCosto,
    ABM_EEX_Clientes,
    ABM_EEX_ClientesSocios,
    ABM_EEX_LocacionesTipos,
    ABM_EEX_Personas,
    ABM_EEX_Profesionales,
    ABM_EEX_ProfesionalesTipos,
    ABM_EEX_Proveedores,
    ABM_GEO_Ciudades,
    ABM_GEO_Paises,
    ABM_GEO_ProvinciasEstados,
    ABM_IMP_PuntosFiscales,
    ABM_IMP_ImpuestosTipos,
    ABM_IMP_TiposIVA,
    ABM_IMP_Terminales,
    ABM_TRA_EmpresasTransporte,
    ABM_TRA_EmpresasTransporteLocaciones,
    ABM_TRA_Transportes,
    ABM_TRA_TransportesTipos,
    ABM_TRA_Transportistas,
    ABM_ZON_Companias,
    ABM_ZON_Depositos,
    ABM_ZON_Empresas,
    ABM_ZON_Plantas,
    ABM_ZON_Ubicaciones,
    COM_Cotizaciones_Cabecera,
    COM_DocsCompra_Cabecera,
    COM_DocsCompra_Tipos,
    COM_Pagos_Cabecera,
    COM_Pagos_Anticipos,
    COM_Pedidos_Cabecera,
    COM_Pedidos_Detalle,
    COM_Recepciones_Cabecera,
    COM,
    CON_Asientos,
    CON_Cheques,
    CON_OperacionesParaImportar,
    CON_Plantilla_OperacionesParaImportar_Cabecera,
    CON_Transferencias,
    CONT_Reportes,
    INV_Remitos_Cabecera,
    INV_MovimientoInventario,
    MKT_Correos_AEnviar,
    PRO_Articulos_BOM,
    PRO_Fabricacion_Cabecera,
    PRO_Fabricacion_Etapas_Cabecera,
    PRO_Fabricacion_Tipos,
    STK_ART_Consumo,
    STK_ART_Merma,
    STK_ART_Stock,
    VEN_CierresDeCaja_Cabecera,
    VEN_CierresDeCaja_Totales,
    VEN_Cotizaciones_Cabecera,
    VEN_DocsVenta_Cabecera,
    VEN_DocsVenta_Tipos,
    VEN_ListasPrecios_Cabecera,
    VEN_ListasPrecios_Detalle,
    VEN_Pedidos_Cabecera,
    VEN_Pedidos_Detalle,
    VEN_PVenta_ArticulosDisponiblesParaEgresos,
    VEN_PVenta_Disposicion_Botones,
    VEN_PVenta_Disposicion_BotonesReservables,
    VEN_PVenta_Disposicion_CuentasFinancieras,
    VEN_PVenta_Disposicion_Grupos,
    VEN_PVenta_Mesas,
    VEN_Recibos_Anticipos,
    VEN_Recibos_Cabecera,
    VEN_Reservas_Cabecera,
    VEN_Reservas_Detalle,
    VEN_Reservas_Integrantes,
    VEN_Reservas_MercadoPago,
    VEN_Reservas_Pulseras,
    VEN,
    VariablesGenerales,
    Varios,
    Mensajes,
    TODOS_Dashboard,
    TODOS_Menues,
    TODOS_Menues_Visibilizar,    
    TODOS_AsistenciaEnLinea_Mensajes
};
